import { ContactQuarantinedMessageBatchFilter, QuarantineStatus } from '@graphql/generated';
import { Flex, ButtonV2, TextV2 } from '@withjoy/joykit';
import { useState, useRef } from 'react';
import { useGetSpamQueue } from '../../hooks/useGetSpamQueue';
import { SpamQueueRow, END_OF_QUEUE_MSGS } from '../../types';
import { SpamRow } from '../Rows/SpamRow';
import { SpamFilters } from '../Filters/SpamFilters';
import { random } from 'lodash-es';
import React from 'react';
import { useRowFilters } from '../../hooks/useRowFilters';

export const QueueView = () => {
  const [cursor, setCursor] = useState<SpamQueueRow['cursor'] | null>(null);
  const [filter, setFilter] = useState<ContactQuarantinedMessageBatchFilter>({
    quarantineStatus: QuarantineStatus.review,
  });
  const endOfQueueMessage = useRef(END_OF_QUEUE_MSGS[random(END_OF_QUEUE_MSGS.length - 1, false)]);
  const { setCurrentRow } = useRowFilters();

  const { data } = useGetSpamQueue(cursor, filter);
  const { rows, canGetMore } = data;

  const setSelectedRow = (row: SpamQueueRow) => {
    setCurrentRow(row.id);
  };

  const handleRowClicked = (row: SpamQueueRow) => {
    setSelectedRow(row);
  };

  const handleLoadMore = () => {
    setCursor(rows[rows.length - 1].cursor);
  };

  const handleSelectFilter = (filterKey: keyof ContactQuarantinedMessageBatchFilter, value: string) => {
    setCursor(null);
    setFilter(oldFilterState => {
      return {
        ...oldFilterState,
        [filterKey]: value,
      };
    });
  };

  return (
    <Flex
      flexDirection="column"
      gap="1rem"
      margin="1rem"
    >
      <SpamFilters
        onSelectFilter={handleSelectFilter}
        activeFilters={filter}
      />
      <Flex flexDirection="column">
        {rows.map((row, index) => {
          return (
            <SpamRow
              key={index}
              data={row}
              onClick={handleRowClicked}
            />
          );
        })}
      </Flex>
      {rows.length !== 0 &&
        (canGetMore ? (
          <ButtonV2 onClick={handleLoadMore}>Load More</ButtonV2>
        ) : (
          <TextV2 textAlign="center">
            {endOfQueueMessage.current}
            <br />
            You&apos;ve reviewed every single message. Refresh if you&apos;d like to check for more.
          </TextV2>
        ))}
    </Flex>
  );
};
